import i18n, { SUPPORTED_LANGUAGES, type AppLanguage } from '../i18n';
import { api } from './api';

/**
 * Dil tercihinin SUNUCU ile senkronu (madde 36, 2026-08-17).
 *
 * **Neden gerekti:** `LanguageSwitcher` dili yalnız `localStorage`'a yazıyordu → yalnız o
 * tarayıcının arayüz metnini çeviriyordu. Bildirim metinleri (push/e-posta/SMS) SUNUCUDA
 * üretildiği için web'de EN seçen kullanıcı Türkçe bildirim almaya devam ediyordu; cron
 * bildirimi üretirken ortada tarayıcı bile yok. Bu yüzden tek otorite `User.locale`.
 *
 * Kural: **sunucu otorite, localStorage önbellek.** Kullanıcı seçtiğinde sunucuya yazılır;
 * açılışta sunucudaki değer varsa arayüz ona hizalanır. Böylece web / iOS / Android üç
 * yüzey tek değerde buluşur.
 */

function isSupported(value: unknown): value is AppLanguage {
  return typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

/**
 * Seçimi sunucuya yaz — **ateşle ve unut**: dil değiştirmek arayüz işi, ağ hatası
 * yüzünden kullanıcıya hata göstermeyiz (bir sonraki değişimde/açılışta yeniden denenir).
 */
export function pushLocale(lang: AppLanguage): void {
  void api.patch('/users/me/locale', { locale: lang }).catch(() => undefined);
}

/**
 * Açılışta sunucudaki tercihi arayüze uygula. Sunucuda değer YOKSA (null) dokunmaz —
 * o durumda mevcut localStorage/tarayıcı dili geçerli kalır ve ilk değişimde sunucuya yazılır.
 */
export async function pullLocale(): Promise<void> {
  try {
    const me = await api.get<{ locale?: string | null }>('/users/me');
    if (isSupported(me.locale) && me.locale !== i18n.resolvedLanguage) {
      await i18n.changeLanguage(me.locale);
    }
  } catch {
    // Sessiz: profil çekilemezse dil mevcut hâliyle kalır (arayüzü bloke etmez).
  }
}
